import {colors} from "@c10h/colors";
// @ts-expect-error TS7016: Could not find a declaration file for module 'color'. '/Users/goksel/Sites/carbon-website-next/node_modules/color/index.js' implicitly has an 'any' type.
import Color from "color";
import {useTranslation} from "ni18n";
import React, {useEffect, useState} from "react";
import {usePrefersReducedMotion} from "src/hooks/usePrefersReducedMotion";

import {SpecialtyId} from "../../../constants/specialtyIds";
import {useGetSoonestInPracticeBySpecialtyId} from "../../../hooks/useGetSoonestTime";
import {getSchedulingRedirectUrl} from "../../../utils/getRedirectUrl";
import {vcData} from "../../_common/_constants";
import {todayTomorrow2, trackToPatient, useInterval} from "../../_common/Carbon";
import {LazyComp} from "../../_common/LazyComp";
import styles from "./Services.module.scss";

const time = 20000;
const timeSec = `${time / 1000}s`;

const Services = ({imgExt, isMobile, pageLoaded}: any) => {
  const i18n = useTranslation();
  const shouldReduceMotion = usePrefersReducedMotion();

  const defaultSlides = [
    {
      specialtyId: SpecialtyId.VIRTUAL_URGENT_CARE,
      head: i18n.t("Everyday Care"),
      text: i18n.t(
        "From preventive to urgent care and everything in between, our virtual care providers are there for you.",
      ),
      color: vcData[SpecialtyId.VIRTUAL_URGENT_CARE].darker2,
      btnColor: "#FFF",
      // btnBgColor: "#24A06D",
      btnText: i18n.t("Book appointment"),
      img: "vcServices0",
      price: vcData[SpecialtyId.VIRTUAL_URGENT_CARE].price,
      firstSlot: useGetSoonestInPracticeBySpecialtyId({
        specialtyId: SpecialtyId.VIRTUAL_URGENT_CARE,
      })?.time,
    },
    {
      specialtyId: SpecialtyId.VIRTUAL_MENTAL_HEALTH,
      head: i18n.t("Mental Health"),
      text: i18n.t(
        "Need to talk things out? Book a virtual session easily through the Carbon Health app. Find a time that works for you and speak to a therapist on your time.",
      ),
      color: vcData[SpecialtyId.VIRTUAL_MENTAL_HEALTH].darker2,
      btnColor: "#FFF",
      // btnBgColor: v5Colors.virtual,
      btnText: i18n.t("Book appointment"),
      img: "vcServices2",
      price: vcData[SpecialtyId.VIRTUAL_MENTAL_HEALTH].price,
      firstSlot: useGetSoonestInPracticeBySpecialtyId({
        specialtyId: SpecialtyId.VIRTUAL_MENTAL_HEALTH,
      })?.time,
    },
    {
      head: i18n.t("Nutritionist "),
      text: i18n.t(
        "We'll work with you to design a nutritional plan that checks off all your boxes.",
      ),
      color: colors.darkMint,
      btnColor: colors.gray800,
      img: "vcServices3",
      comingSoon: true,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [delay, setDelay] = useState(time);
  const [pause, setPause] = useState(true);

  const startTime = Date.now();

  useInterval(
    () => {
      if (!isMobile) {
        setActiveIndex((activeIndex + 1) % defaultSlides.length);
      }
    },
    delay,
    pause,
  );

  // @ts-expect-error TS7006: Parameter 'specialtyId' implicitly has an 'any' type.
  const redirectToSpecialty = specialtyId => {
    trackToPatient();
    window.open(
      getSchedulingRedirectUrl({
        virtual: true,
        specialtyId,
      }),
      "_blank",
      "noopener,noreferrer",
    );
  };

  useEffect(() => {
    setDelay(time);
  }, [activeIndex]);

  const renderContent = () => (
    <div className={`dg gac bg-smoke ${styles.wrap}`} id="servicesWrap">
      <div className="tac mobileContainer">
        <div className={styles.leftInner}>
          <h2>{i18n.t("Virtual Care, 365 days a year")}</h2>

          <div
            className={styles.rows}
            onMouseEnter={() => {
              const timeLeft = delay - (Date.now() - startTime);
              setDelay(timeLeft);
              setPause(true);
            }}
            onMouseLeave={() => {
              setPause(false || shouldReduceMotion);
            }}
          >
            {defaultSlides.map(
              (
                {
                  specialtyId,
                  head,
                  text,
                  color,
                  btnColor,
                  btnText,
                  img,
                  price,
                  comingSoon,
                  firstSlot,
                },
                i,
              ) => (
                <div key={head} className={`${styles.row} ${activeIndex === i ? "active" : ""}`}>
                  <div
                    className={styles.mobilImg}
                    style={{backgroundImage: `url(/static/img/v5/${img}.${imgExt})`}}
                  />
                  {pageLoaded && (
                    <div className={styles.rowSpinner} aria-hidden>
                      <div className="spinerContainer">
                        <div
                          className="pie spinner"
                          style={{
                            "--bg": color,
                            "--time": timeSec,
                            "--state": pause ? "paused" : "running",
                          }}
                        />
                        <div
                          className="pie filler"
                          style={{
                            "--bg": color,
                            "--time": timeSec,
                            "--state": pause ? "paused" : "running",
                          }}
                        />
                        <div
                          className="mask"
                          style={{"--time": timeSec, "--state": pause ? "paused" : "running"}}
                        />
                      </div>
                    </div>
                  )}

                  <button
                    className={`df aic bg-inherit p0 mo brdn cp ${styles.rowsTW}`}
                    onClick={() => setActiveIndex(i)}
                    aria-expanded={activeIndex === i}
                    aria-controls={`service-desc-${i}`}
                  >
                    <h3 className={styles.rowHead}>{head}</h3>
                    {price && <span className={styles.rowPrice}>{price}</span>}
                    {comingSoon && <span className={styles.rowSoon}>{i18n.t("Coming Soon")}</span>}
                  </button>

                  <div className={styles.rowBody} id={`service-desc-${i}`}>
                    <div className="color-nevada fs20 lh12 mt4 lh15">{text}</div>
                    {btnText && (
                      <div>
                        <div className="dig aic mt4 gg8 gg4-md">
                          <button
                            type="button"
                            className={`fbce btn bold-f ${styles.btn}`}
                            style={{
                              "--color": btnColor,
                              "--btnBgColor": color,
                              "--btnHoverBg": Color(color).lighten(0.2),
                            }}
                            onClick={() => redirectToSpecialty(specialtyId)}
                            onFocus={() => setActiveIndex(i)}
                          >
                            {btnText}
                            <span className="visually-hidden">{head}</span>
                          </button>
                          {firstSlot && (
                            <div
                              className={styles.times}
                              style={{"--color": vcData[specialtyId].darker2}}
                            >
                              <span className="desktopOnly">{i18n.t("Next:")}</span>
                              <span className={`bold ml1 ${styles.times__inner}`}>
                                {todayTomorrow2(i18n.lang, firstSlot)}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
      </div>
      <div className="pos-r desktopOnly">
        {defaultSlides.map((s, i) => (
          <LazyComp key={s.head}>
            <div
              className={`${i === activeIndex ? "on" : ""} ${styles.rightImg}`}
              style={{backgroundImage: `url(/static/img/v5/${s.img}.${imgExt})`}}
            />
          </LazyComp>
        ))}
      </div>
    </div>
  );

  return renderContent();
};

export default Services;
